/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MyProfileTeam
 */
export interface MyProfileTeam {
  /**
   *
   * @type {string}
   * @memberof MyProfileTeam
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof MyProfileTeam
   */
  name: string;
}

/**
 * Check if a given object implements the MyProfileTeam interface.
 */
export function instanceOfMyProfileTeam(value: object): value is MyProfileTeam {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function MyProfileTeamFromJSON(json: any): MyProfileTeam {
  return MyProfileTeamFromJSONTyped(json, false);
}

export function MyProfileTeamFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MyProfileTeam {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    name: json["name"],
  };
}

export function MyProfileTeamToJSON(json: any): MyProfileTeam {
  return MyProfileTeamToJSONTyped(json, false);
}

export function MyProfileTeamToJSONTyped(
  value?: MyProfileTeam | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    name: value["name"],
  };
}
